/**
 * goToChannelsClassic action.
 */
import Channel from '../../classes/channel';
import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

interface Props {
  channel?: Channel;
}

/**
 * Function to redirect to the classic channel page.
 * If a channel is given, it will be focused once the page loads.
 */
export default function goToChannelsClassic({ channel }: Props = {}) {
  const { channels } = store.getState();
  const firstChannel = channels.channelsData?.[0];
  store.dispatch(
    pushRoute({
      route: { Page: Pages.CHANNELS_CLASSIC, overwrite: true },
      params: {
        current: {
          channel,
          channelId: channel?.id || firstChannel?.id,
        },
        stack: {
          stacked: false,
        },
        push: false,
      },
    })
  );
}
